import {
  GET_ALL_SUBSCRIPTION,
  GET_RUNNING_SUBSCRIPTION,
  GET_DASHBOARD_DETAILS,
  GET_ALL_SUBS_HISTORY,
  GET_ALL_CARDS,
} from './actions'

const initialState = {
  getSubscription: [],
  runningSubscription: {},
  dashboardDetails: {},
  subscriptionHistory: {},
  loading: true,
  allCards: [],
}

const subscriptionReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_ALL_SUBSCRIPTION:
      return {
        ...state,
        getSubscription: payload,
        loading: false,
      }
    case GET_RUNNING_SUBSCRIPTION:
      return {
        ...state,
        runningSubscription: payload,
        loading: false,
      }
    case GET_DASHBOARD_DETAILS:
      return {
        ...state,
        dashboardDetails: payload,
        loading: false,
      }
    case GET_ALL_SUBS_HISTORY:
      return {
        ...state,
        loading: false,
        subscriptionHistory: payload,
      }
    case GET_ALL_CARDS:
      return {
        ...state,
        allCards: payload,
        loading: false,
      }
    default:
      return state
  }
}
export default subscriptionReducer
